import React from 'react';
import StarRating from './StarRating';

const ReviewCard = ({ name, avatar, rating, review, uniformHeight }) => {
  const cardStyle = uniformHeight > 0 ? { height: `${uniformHeight}px` } : {};

  return (
    <article
      className="flex flex-col justify-between items-center w-full max-w-[260px] sm:max-w-[280px] md:max-w-[300px] lg:max-w-[320px] min-w-0 min-h-[220px]
       sm:min-h-[270px] md:min-h-[320px] lg:min-h-[340px] px-2 sm:px-3 md:px-4 lg:px-6 py-3 sm:py-4 md:py-6 lg:py-8 border-solid border-[4px] sm:border-[6px]
        border-zinc-800 rounded-[32px] sm:rounded-[48px] shadow-[0px_6px_0px_rgba(40,42,47,1)] sm:shadow-[0px_8px_0px_rgba(40,42,47,1)] transition-all 
        duration-300 hover:shadow-[0px_8px_0px_rgba(40,42,47,1)] sm:hover:shadow-[0px_12px_0px_rgba(40,42,47,1)] hover:border-teal-600 hover:bg-gradient-to-br
         hover:from-white hover:to-gray-50 bg-white mx-auto group overflow-hidden"
      style={cardStyle}
      role="article"
      aria-labelledby={`review-name-${name.replace(/\s+/g, '-').toLowerCase()}`}
      aria-describedby={`review-text-${name.replace(/\s+/g, '-').toLowerCase()}`}
    >
      {/* Avatar Section */}
      <div className="flex-shrink-0 mb-2 sm:mb-3 md:mb-0 transition-transform duration-300 group-hover:-translate-y-1">
        <img
          src={avatar}
          alt={`${name}'s profile picture`}
          className="object-cover rounded-full w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] md:w-[100px] md:h-[100px] lg:w-[120px] lg:h-[120px] ring-2 sm:ring-4 ring-transparent group-hover:ring-teal-200 transition-all duration-300"
          loading="lazy"
        />
      </div>

      {/* Content Section */}
      <div className="flex flex-col items-center flex-1 w-full space-y-1 sm:space-y-2 md:space-y-3 min-w-0">
        {/* Name */}
        <h3
          id={`review-name-${name.replace(/\s+/g, '-').toLowerCase()}`}
          className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-center text-teal-800 leading-tight px-1 sm:px-2 group-hover:text-teal-600 transition-colors duration-300 w-full break-words overflow-hidden"
        >
          <span className="block truncate">{name}</span>
        </h3>

        {/* Rating */}
        <div
          className="flex-shrink-0 transform group-hover:scale-110 transition-transform duration-300"
          role="img"
          aria-label={`Rating: ${rating} out of 5 stars`}
        >
          <StarRating rating={rating} size={16} />
        </div>

        {/* Review Text - Always 3 lines with ellipsis */}
        <div className="flex-1 w-full flex items-center justify-center px-1 sm:px-2 md:px-3 lg:px-4 min-w-0">
          <blockquote
            id={`review-text-${name.replace(/\s+/g, '-').toLowerCase()}`}
            className="text-xs sm:text-sm md:text-base leading-4 sm:leading-5 md:leading-6 text-center text-black group-hover:text-gray-800 transition-colors duration-300 w-full overflow-hidden"
          >
            <span className="line-clamp-3 break-words hyphens-auto w-full block overflow-hidden">
              "{review}"
            </span>
          </blockquote>
        </div>
      </div>

      <style jsx>{`
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-wrap: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
          line-height: 1.4;
        }

        /* Ensure consistent 3-line clamping across all screen sizes */
        @media (max-width: 640px) {
          .line-clamp-3 {
            -webkit-line-clamp: 3;
            line-height: 1.3;
          }
        }

        @media (min-width: 641px) and (max-width: 768px) {
          .line-clamp-3 {
            -webkit-line-clamp: 3;
            line-height: 1.4;
          }
        }

        @media (min-width: 769px) {
          .line-clamp-3 {
            -webkit-line-clamp: 3;
            line-height: 1.5;
          }
        }
      `}</style>
    </article>
  );
};

export default ReviewCard;
